import { render, staticRenderFns } from "./LinkedAccountsList.vue?vue&type=template&id=873e2b4c&scoped=true"
import script from "./LinkedAccountsList.vue?vue&type=script&lang=ts"
export * from "./LinkedAccountsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873e2b4c",
  null
  
)

export default component.exports